import type { FormationProgress } from '@/api/formation';
import type { TutoId } from '@/features/tutorials';

export type FormationStepKey = Exclude<keyof FormationProgress, 'manager'>;

export type FormationStep = {
  readonly key: FormationStepKey;
  readonly title: string;
  readonly hint: string;
  readonly route: string;
  /** Étape de mise en place du commerce : affichée au gérant seulement. */
  readonly managerOnly: boolean;
  /** Tuto vidéo d'une minute associé (bouton « Voir le tuto »). */
  readonly tutoId?: TutoId;
};

/** Parcours de prise en main, dans l'ordre conseillé. */
export const FORMATION_STEPS: readonly FormationStep[] = [
  {
    key: 'article',
    title: 'Ajouter un article',
    hint: 'Nom, prix, TVA',
    route: '/produits',
    managerOnly: true,
    tutoId: 'visionpos-tuto-articles-stocks',
  },
  {
    key: 'imprimante',
    title: 'Configurer l’imprimante',
    hint: 'Ticket et bon cuisine',
    route: '/imprimantes',
    managerOnly: true,
    tutoId: 'visionpos-tuto-imprimante-tpe',
  },
  {
    key: 'premiere_vente',
    title: 'Faire une première vente',
    hint: 'Ticket remis au client',
    route: '/caisse',
    managerOnly: false,
    tutoId: 'visionpos-tuto-encaisser',
  },
  {
    key: 'vente_carte',
    title: 'Encaisser par carte',
    hint: 'Paiement sur le terminal',
    route: '/caisse',
    managerOnly: false,
    tutoId: 'visionpos-tuto-encaisser',
  },
  {
    key: 'cloture_z',
    title: 'Faire la clôture Z',
    hint: 'En fin de journée',
    route: '/clotures-z',
    managerOnly: true,
    tutoId: 'visionpos-tuto-cloture',
  },
  {
    key: 'equipe',
    title: 'Ajouter un membre de l’équipe',
    hint: 'Vendeur, serveur…',
    route: '/utilisateurs',
    managerOnly: true,
  },
];

/** Étapes visibles pour ce profil et nombre faites. */
export function visibleSteps(progress: FormationProgress) {
  const steps = FORMATION_STEPS.filter((s) => progress.manager || !s.managerOnly);
  const done = steps.filter((s) => progress[s.key]).length;
  return { steps, done, total: steps.length };
}
